import Const from "@/helpers/Const";

export const PromoMixin = {
  methods: {
    setPromoRate(promo, costService) {
      let val = 0;
      //비율
      if (promo.type_rate == Const.PROMO_TYPE_RATE_RATE) {
        let promo_base_rate = costService * promo.rate * 0.01;
        promo_base_rate = promo_base_rate * (1 / (promo.cut_standard * 10));
        switch (promo.cut_unit) {
          case Const.PROMO.CUT_UNIT.FLOOR: //버림
            promo_base_rate = Math.floor(promo_base_rate);
            break;
          case Const.PROMO.CUT_UNIT.ROUND: //반올림
            promo_base_rate = Math.round(promo_base_rate);
            break;
          case Const.PROMO.CUT_UNIT.CEIL: //올림
            promo_base_rate = Math.ceil(promo_base_rate);
            break;
        }
        val = promo_base_rate * promo.cut_standard * 10;
      }
      //금액
      else if (promo.type_rate == Const.PROMO_TYPE_RATE_UNIT) {
        val = promo.rate;
      }
      return val;
    },
  }
}